import { IFetchSubsetOptionsCompletedAction, SUBSET_OPTION_FETCH_COMPLETED } from "../action-creators/subset-options";
import { TApiSubsetOptions } from "../../api/endpoints/SubsetOption";

// const initialItemState = {
//   loading: false,
//   loadedAt: null,
//   error: null,
//   data: null
// };

export type TOptionsBySubsetIdState = {
  [id: string]: {
    loading: boolean;
    loadedAt: null | number;
    error: null | Error;
    data: TApiSubsetOptions | null
  }
};

type TAllowedActions = IFetchSubsetOptionsCompletedAction;

const updateOptions = (state: TOptionsBySubsetIdState, subsetId: number, options: TApiSubsetOptions) => {
  return {
    ...state,
    [subsetId]: {
      ...state[subsetId],
      data: options,
      loading: false,
      loadedAt: Date.now(),
      error: null
    }
  }
}

const optionsBySubsetId = (state: TOptionsBySubsetIdState = {}, action: TAllowedActions) => {
  switch (action.type) {
    case SUBSET_OPTION_FETCH_COMPLETED:
      return updateOptions(state, action.subsetId, action.options);

    default:
      return state;
  }
}

export default optionsBySubsetId;
